var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgRenew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.39 5.00083H6V6.00083H2V2.00083H3V3.84083C3.85447 2.81217 5.00541 2.07209 6.29589 1.7215C7.58637 1.37091 8.95358 1.42688 10.2111 1.88177C11.4686 2.33666 12.5552 3.16833 13.3227 4.26339C14.0903 5.35844 14.5014 6.66358 14.5 8.00083H13.5C13.5001 6.81513 13.117 5.66114 12.4078 4.7109C11.6986 3.76065 10.7013 3.06503 9.56462 2.72773C8.4279 2.39042 7.21261 2.42949 6.09991 2.83912C4.98721 3.24875 4.03667 4.007 3.39 5.00083ZM12.61 11.0007H10V10.0007H14V14.0007H13V12.1607C12.1455 13.1894 10.9946 13.9295 9.70411 14.2801C8.41363 14.6307 7.04642 14.5747 5.78892 14.1198C4.53141 13.6649 3.4448 12.8332 2.67727 11.7382C1.90973 10.6431 1.49863 9.33799 1.5 8.00073H2.5C2.49993 9.18644 2.88303 10.3404 3.59221 11.2907C4.30139 12.2409 5.29867 12.9365 6.43539 13.2738C7.5721 13.6111 8.78739 13.5721 9.90009 13.1624C11.0128 12.7528 11.9633 11.9946 12.61 11.0007Z",
    fill: "#2767A9"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRenew);
export default __webpack_public_path__ + "static/media/renew.675da6ad3080bae5b4d62139779956d3.svg";
export { ForwardRef as ReactComponent };